export const PAID_IMAGE_TYPE = 'PAID';
export const AGE_VALIDATION = 'AGE_VALIDATION';
export const SUGGESTED_IMAGE_TYPE = 'SUGGESTED';
export const getImage = (section, type = PAID_IMAGE_TYPE) =>
  section.images?.find(img => img.type === type);

export const getIsAgeValidation = section =>
  section?.restrictions?.includes(AGE_VALIDATION) || false;

const isMaxQuantityInvalid = maxQuantity =>
  maxQuantity === null || maxQuantity === 0;

const fixProductMaxQuantity = products =>
  products?.map(p => ({
    ...p,
    maxQuantity: isMaxQuantityInvalid(p.maxQuantity) ? 99 : p.maxQuantity,
  }));

export function Section({
  id,
  name,
  image,
  products,
  totalProducts,
  requiresAgeCheck,
  customImage,
}) {
  return {
    id,
    name,
    image,
    products: fixProductMaxQuantity(products),
    totalProducts,
    requiresAgeCheck,
    customImage,
  };
}

export const mapProducts = products =>
  products?.map(
    ({
      id,
      name,
      campaigns,
      pricing: {
        price,
        pricePerMeasurementUnit,
        formattedPrices,
        priceWithoutTax: finalPriceWithoutTaxes,
      },
      maxQuantity,
      requiresAgeCheck = false,
      absoluteImages,
    }) => {
      const image = absoluteImages && absoluteImages[0];
      const { priceWithoutTax } = formattedPrices || {};

      return {
        id: Number(id),
        name,
        campaigns,
        price,
        pricePerMeasurementUnit,
        image,
        maxQuantity,
        requiresAgeCheck,
        priceWithoutTax,
        finalPriceWithoutTaxes,
      };
    },
  );

export default function MenuShelvesCategoryTree({ total, count, sections }) {
  return {
    total,
    count,
    sections:
      sections?.map(section =>
        Section({
          id: section.globalId,
          name: section.name,
          image: getImage(section),
          customImage: getImage(section, SUGGESTED_IMAGE_TYPE),
          requiresAgeCheck: getIsAgeValidation(section),
          products: mapProducts(section.products),
          totalProducts: section.children_qty,
        }),
      ) || [],
  };
}

export function MenuGridCategoryTree({ sections }) {
  return (
    sections?.map(section =>
      Section({
        id: section.globalId,
        name: section.name,
        customImage: getImage(section, SUGGESTED_IMAGE_TYPE),
        requiresAgeCheck: getIsAgeValidation(section),
        totalProducts: section.children_qty,
      }),
    ) || []
  );
}
